import $ from 'jquery';

let youtubeID;

export default class {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.modify();
    this.ready();
  }

  modify() {
    // Transform the main destinations to play the video.
    const videoSrc = this.$element.find('.field-video a').eq(0).attr('href');
    const videoWrapper = this.$element.find('.video-play');

    videoWrapper.append('<div id="player"></div>');
    youtubeID = videoSrc.match('embed/(.*)autoplay')[1].slice(0, -1);

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  ready() {
    const tag = document.createElement('script');
    tag.type = 'text/javascript';
    tag.text = `let player;
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: '${youtubeID}',
        playerVars: {
          'playsinline': 1,
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange,
        },
      });
    }

    function onPlayerReady(event) {
      event.target.playVideo();
      player.mute();
    }

    const done = false;
    function onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.ENDED) {
        player.seekTo(0);
        player.playVideo();
      }
    }
    function stopVideo() {
      player.stopVideo();
    }`;
    document.body.appendChild(tag);

    return this.$element.addClass('ready');
  }
}
